module.exports = function getResource(label, vars = []) {
    let resources = {
        reviewfor: `Review For ${vars[0]}`,
        imagesTitle: 'Images from this review',
        verifiedPurchase: 'Verified Purchase',
        recommended: 'Recommended',
        readMore: 'Read more',
        readLess: 'Read less'
    };
    return resources[label];
};
